import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationContactEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationByUserId = null;
        this.creationDTTM = new Date(0);
        this.email = null;
        this.firstName = null;
        this.lastName = null;
        this.organizationContactId = 0;
        this.organizationId = 0;
        this.phoneNumber = null;
        this.title = null;
        this.updatedByUserId = null;
        this.updatedDTTM = null;
        this.userId = null;
    }
    pk() {
        return this.organizationContactId.toString();
    }
}
OrganizationContactEntity.schema = { creationDTTM: ISODate, updatedDTTM: ISODate };
OrganizationContactEntity.key = 'OrganizationContact';
export { OrganizationContactEntity };
